//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PrettyPrint from "./pretty-print";

export default {
    name: "schema-test",
    components: [
        "q-input",
        'q-checkbox',
        'q-btn',
        'q-tooltip',
        'q-select',
        'q-file'
    ],
    created() {
        //TODO: Axios call to Backend API, get JSON Schema
        var schema = {
            "schema": {
                "type": "object",
                "required": ["textExample", "checkbox-example", "single-select-example", "file-upload-example"],
                "properties": {
                    "textExample": {
                        "type": "string",
                        "minLength": 5,
                        "ui": {
                            "grid": ["col", "col-md-6"],
                            "type": "text",
                            "classNames": ["foo", "bar"],
                            "label": "Field Name",
                            "tooltip": {
                                "icon": "info",
                                "text": "Lorem Ipsum dolot sit amet."
                            },
                            "disabled": false,
                            "placeholder": "Lorem Ipsum.",
                            "prefix": "GBP",
                            "suffix": "EUR",
                            "prepend": {
                                "innerHTML": "Prepend Content",
                                "classNames": ["foo", "bar"],
                                "component": "span"
                            },
                            "append": {
                                "innerHTML": "Append Content",
                                "classNames": ["foo", "bar"],
                                "component": "span"
                            },
                            "before": {
                                "innerHTML": "Before Content",
                                "classNames": ["foo", "bar"],
                                "component": "span"
                            },
                            "after": {
                                "innerHTML": "After Content",
                                "classNames": ["foo", "bar"],
                                "component": "span"
                            },
                            "validation": {
                                "required": "Fehlermeldung Required",
                                "minLength": "Fehlermeldung MinLength"
                            }
                        }
                    },
                    "dateExample": {
                        "type": "string",
                        "minLength": 5,
                        "ui": {
                            "grid": ["col", "col-md-6"],
                            "type": "date",
                            "classNames": ["foo", "bar"],
                            "label": "Field Name",
                            "tooltip": {
                                "icon": "info",
                                "text": "Lorem Ipsum dolot sit amet."
                            },
                            "placeholder": "Lorem Ipsum.",
                            "validation": {
                                "required": "Fehlermeldung Required",
                                "minLength": "Fehlermeldung MinLength"
                            }
                        }
                    },
                    "checkbox-example": {
                        "type": "boolean",
                        "ui": {
                            "grid": ["col", "col-md-6"],
                            "type": "checkbox",
                            "classNames": ["foo", "bar"],
                            "label": "Field Name",
                            "checked": true,
                            "prepend": {
                                "innerHTML": "",
                                "classNames": ["foo", "bar"],
                                "component": "span"
                            },
                            "append": {
                                "innerHTML": "",
                                "classNames": ["foo", "bar"],
                                "component": "span"
                            },
                            "before": {
                                "innerHTML": "",
                                "classNames": ["foo", "bar"],
                                "component": "span"
                            },
                            "after": {
                                "innerHTML": "",
                                "classNames": ["foo", "bar"],
                                "component": "span"
                            },
                            "validation": {
                                "required": "Fehlermeldung Required"
                            }
                        },
                        "const": true
                    },
                    "single-select-example": {
                        "type": "object",
                        "ui": {
                            "grid": ["col", "col-md-6"],
                            "type": "single-select",
                            "classNames": ["foo", "bar"],
                            "label": "Field Name",
                            "options": [
                                {
                                    "label": "Key 1",
                                    "value": "Value 1",
                                    "disable": false
                                }
                            ],
                            "selected": "Key 1",
                            "tooltip": {
                                "icon": "info",
                                "text": "Lorem Ipsum dolot sit amet."
                            },
                            "disabled": false,
                            "prepend": {
                                "innerHTML": "",
                                "classNames": ["foo", "bar"],
                                "component": "div"
                            },
                            "before": {
                                "innerHTML": "",
                                "classNames": ["foo", "bar"],
                                "component": "div"
                            },
                            "after": {
                                "innerHTML": "",
                                "classNames": ["foo", "bar"],
                                "component": "div"
                            },
                            "validation": {
                                "required": "Fehlermeldung Required"
                            }
                        }
                    },
                    "file-upload-example": {
                        "type": "object",
                        "ui": {
                            "grid": ["col", "col-md-6"],
                            "type": "file",
                            "classNames": ["foo", "bar"],
                            "label": "Field Name",
                            "icon": "folder_open",
                            "disabled": false,
                            "prepend": {
                                "innerHTML": "",
                                "classNames": ["foo", "bar"],
                                "component": "div"
                            },
                            "append": {
                                "innerHTML": "",
                                "classNames": ["foo", "bar"],
                                "component": "div"
                            },
                            "before": {
                                "innerHTML": "",
                                "classNames": ["foo", "bar"],
                                "component": "div"
                            },
                            "after": {
                                "innerHTML": "",
                                "classNames": ["foo", "bar"],
                                "component": "div"
                            },
                            "validation": {
                                "size": {
                                    "maximum": "Fehlermeldung Size"
                                },
                                "type": {
                                    "enum": "Fehlermeldung Enum"
                                }
                            }
                        },
                        "properties": {
                            "size": {
                                "maximum": 2048
                            },
                            "type": {
                                "enum": ["image/png", "image/jpeg", "image/jpg", "image/gif"]
                            }
                        }
                    }
                }
            }
        };

        var result = this.$convertJSONSchema(schema.schema);
        var uiSchema = result.schema;

        this.model = result.model;
        this.schema = schema.schema;
        this.uiSchema = uiSchema;
    },
    data() {
        return {
            model: {},
            state: {},
            valid: false,
            options: {
                castToSchemaType: true
            },
            submitted: false,
            success: false,
            schema: {},
            uiSchema: [],
            test: {"foo": "bar"},
            orange: {},
            date: '2019/02/01'
        };
    },
    methods: {
        onChangeState(value) {
            this.state = value;
        },
        onValidated(value) {
            this.valid = value;
        },
        onSubmit(e) {
            e.preventDefault();

            this.submitted = true;
            this.options = {
                ...this.options,
                showValidationErrors: true
            };

            if (this.valid) {
                this.success = true;
            }
        }
    }
};
